var service = {
    mapLibraries: ['places'],
    REACT_APP_GOOGLE_MAP_KEY: 'AIzaSyB_0OwcvvHVGQGPT5FA8Hl3LpYBxC1vvmA'
};
if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://api-evoter.mksdigitech.com';
} else {
    service.API_URL = 'http://192.168.1.185:5005';
}

export default service;
